import React from "react";
import "./Trusted.css";

import sliderImg1 from "../../Images/sliderImg/sliderImg1.png";
import sliderImg2 from "../../Images/sliderImg/sliderImg2.png";
import sliderImg3 from "../../Images/sliderImg/sliderImg3.jpg";
import sliderImg4 from "../../Images/sliderImg/sliderImg4.png";
import sliderImg5 from "../../Images/sliderImg/sliderImg5.png";
import sliderImg6 from "../../Images/sliderImg/sliderImg6.png";
import sliderImg7 from "../../Images/sliderImg/sliderImg7.png";
import sliderImg8 from "../../Images/sliderImg/sliderImg8.png";
import sliderImg9 from "../../Images/sliderImg/sliderImg9.jpg";
import sliderImg10 from "../../Images/sliderImg/sliderImg10.webp";
import sliderImg11 from "../../Images/sliderImg/sliderImg11.png";
import sliderImg12 from "../../Images/sliderImg/sliderImg12.webp";
import sliderImg13 from "../../Images/sliderImg/sliderImg13.jpg";
import sliderImg14 from "../../Images/sliderImg/sliderImg14.png";
import sliderImg15 from "../../Images/sliderImg/sliderImg15.png";
import sliderImg16 from "../../Images/sliderImg/sliderImg16.png";
import sliderImg17 from "../../Images/sliderImg/sliderImg17.png";
import sliderImg18 from "../../Images/sliderImg/sliderImg18.png";
import sliderImg19 from "../../Images/sliderImg/sliderImg19.png";
import sliderImg20 from "../../Images/sliderImg/sliderImg20.jpg";
import sliderImg21 from "../../Images/sliderImg/sliderImg21.png";
import sliderImg22 from "../../Images/sliderImg/sliderImg22.png";
import sliderImg23 from "../../Images/sliderImg/sliderImg23.jpg";
import sliderImg24 from "../../Images/sliderImg/sliderImg24.jpg";
import sliderImg25 from "../../Images/sliderImg/sliderImg25.png";
import sliderImg26 from "../../Images/sliderImg/sliderImg26.png";
import sliderImg27 from "../../Images/sliderImg/sliderImg27.jpg";
import sliderImg28 from "../../Images/sliderImg/sliderImg28.jpg";

export default function TrustedBy() {
  const images = [
    sliderImg1, sliderImg2, sliderImg3, sliderImg4, sliderImg5,
    sliderImg6, sliderImg7, sliderImg8, sliderImg9, sliderImg10,
    sliderImg11, sliderImg12, sliderImg13, sliderImg14, sliderImg15,
    sliderImg16, sliderImg17, sliderImg18, sliderImg19, sliderImg20,
    sliderImg21, sliderImg22, sliderImg23, sliderImg24, sliderImg25,
    sliderImg26, sliderImg27, sliderImg28
  ];

  return (
    <div className="compContainer">
      <h3>Trusted by Industry Leaders Worldwide</h3>
      <div className="slider">
        <div className="compIcons">
          {images.concat(images).map((img, index) => (
            <img key={index} src={img} alt={`companyIcon-${index}`} />
          ))}
        </div>
      </div>
    </div>
  );
}
